import { GET_TOKEN_FAIL, GET_TOKEN_REQUEST, GET_TOKEN_SUCCESS } from "../constant";

const initialState = {
    token:''
}

const TokenReducer = (state = initialState, action) => { 
    switch (action.type) {
       case GET_TOKEN_REQUEST:
          return {
            ...state,
            token:''
          }
          case GET_TOKEN_SUCCESS:
          return {
            ...state,
            token:action?.payload
          }
          case GET_TOKEN_FAIL:
          return {
            ...state,
            token:''
          }
       default:
          return state;
    }
 }

 export default TokenReducer